import { PicklistDataItem, PicklistQueryResponse } from "../../../../Engine/Core/Picklists/PicklistTypes";
import { DigestQueryFilter } from "../../../../../../Common/CandyApiClient/DigestApiClient/Types/DigestQueryFilter";
import { buildEqualValueFilter, buildSearchFilter } from "../Common/PicklistFilterBuilder";
import { FilterBuilder, IFilterBuilder, ResolveToAllFilter, ResolveToNoneFilter } from "../Common/FilterBuilder";

import { TreeQueryResponse } from "./TreePicklistModal/TreePicklistModal";

export interface TreePicklistItemResponse extends PicklistDataItem {
    childrenCount: string;
}

const strictCastResponseToTreeQueryResponse = (response: PicklistQueryResponse): TreeQueryResponse =>
    response as unknown as TreeQueryResponse;

export interface BaseTreePicklistSearchProps {
    onQueryPicklist: (filter: DigestQueryFilter) => Promise<PicklistQueryResponse>;

    searchByField: string;
    searchFields: { [x: string]: undefined | string };
    fields: string[];
    filter?: (
        builder: FilterBuilder,
        none: ResolveToNoneFilter,
        all: ResolveToAllFilter
    ) => null | undefined | FilterBuilder | ResolveToAllFilter | ResolveToNoneFilter;
}

export enum SummaryState {
    Checked = "Checked",
    Unchecked = "Unchecked",
    Indeterminate = "Indeterminate",
}

export interface UniqValueExtractor {
    getItemValue: () => string;
}

export type TreeQuery = (filterQueryOptions: FilterQueryOptions) => Promise<TreeQueryResponse>;

export interface FilterQueryOptions {
    nodeFilter: IFilterBuilder;
    searchQuery?: string;
    take?: number;
    skip?: number;
}

export const getTreePickListItemsBySearchQuery = async (
    { searchQuery, nodeFilter, take, skip }: FilterQueryOptions,
    picklistProps: BaseTreePicklistSearchProps
): Promise<TreeQueryResponse> => {
    const { onQueryPicklist, searchByField } = picklistProps;
    const filter = searchQuery ? buildEqualValueFilter(searchQuery, searchByField) : nodeFilter.build();

    const filterQuery: DigestQueryFilter = {
        filter: filter,
        take: take,
        skip: skip,
        isTree: true,
    };

    const response = strictCastResponseToTreeQueryResponse(await onQueryPicklist(filterQuery));
    return response;
};

export const getTreePickListItemsByValue = async (
    { searchQuery, nodeFilter, take, skip }: FilterQueryOptions,
    picklistProps: BaseTreePicklistSearchProps
): Promise<TreeQueryResponse> => {
    const { onQueryPicklist, fields } = picklistProps;
    const filter = searchQuery ? buildSearchFilter(searchQuery, fields) : nodeFilter.build();

    const filterQuery: DigestQueryFilter = {
        filter: filter,
        take: take,
        skip: skip,
        isTree: true,
    };

    const response = strictCastResponseToTreeQueryResponse(await onQueryPicklist(filterQuery));
    return response;
};
